import React from 'react';
import { motion } from 'framer-motion';
import { Sun, CloudRain, Sparkles } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  
  return (
    <motion.button
      onClick={toggleTheme}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 px-4 sm:px-5 py-3 sm:py-4 rounded-full backdrop-blur-md transition-all duration-500 focus:outline-none focus:ring-2 focus:ring-white/50 border-2"
      style={{
        background: theme === 'sunrise' 
          ? 'linear-gradient(135deg, rgba(16,185,129,0.95) 0%, rgba(5,150,105,0.95) 100%)'
          : 'linear-gradient(135deg, rgba(251,191,36,0.9) 0%, rgba(249,115,22,0.9) 100%)',
        boxShadow: theme === 'sunrise'
          ? '0 4px 30px rgba(16,185,129,0.5), 0 0 60px rgba(16,185,129,0.3)'
          : '0 4px 20px rgba(251,191,36,0.4)',
        borderColor: theme === 'sunrise' ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.2)',
      }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      animate={{
        boxShadow: theme === 'sunrise' 
          ? ['0 4px 30px rgba(16,185,129,0.5), 0 0 60px rgba(16,185,129,0.3)', '0 4px 40px rgba(16,185,129,0.7), 0 0 80px rgba(16,185,129,0.4)', '0 4px 30px rgba(16,185,129,0.5), 0 0 60px rgba(16,185,129,0.3)']
          : '0 4px 20px rgba(251,191,36,0.4)'
      }}
      transition={{ 
        boxShadow: { duration: 2, repeat: Infinity, ease: "easeInOut" }
      }}
      aria-label={theme === 'sunrise' ? 'Switch to brainstorm theme' : 'Switch to sunrise theme'}
    >
      <motion.div
        initial={false}
        animate={{ rotate: theme === 'sunrise' ? 0 : 180 }}
        transition={{ duration: 0.5 }}
        className="relative"
      >
        {theme === 'sunrise' ? (
          <CloudRain className="w-5 h-5 sm:w-6 sm:h-6 text-white" aria-hidden="true" />
        ) : (
          <Sun className="w-5 h-5 sm:w-6 sm:h-6 text-white" aria-hidden="true" />
        )}
      </motion.div>
      <span className="text-sm sm:text-base font-bold text-white whitespace-nowrap">
        {theme === 'sunrise' ? 'make it rain in the brainstorm' : 'back to manifesting'}
      </span>
      {theme === 'sunrise' && (
        <motion.div
          animate={{ scale: [1, 1.2, 1], opacity: [0.7, 1, 0.7] }}
          transition={{ duration: 1.5, repeat: Infinity }}
        >
          <Sparkles className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
        </motion.div>
      )}
    </motion.button>
  );
};

export default ThemeToggle;
